import { type ReactNode } from "react";

import { type StatsItem } from "../models";

import { Wrapper } from "./formatTooltipContent.styles";

export const formatTooltipContent =
    (contentName: ReactNode, formatter: (value: number) => string) =>
    ({ value, isDateIncomplete }: StatsItem): ReactNode => {
        if (isDateIncomplete) {
            return (
                <Wrapper>
                    {formatter(value)} {contentName}
                    {/* TODO add message from PM */}
                </Wrapper>
            );
        }

        return (
            <>
                {formatter(value)} {contentName}
            </>
        );
    };
